/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
// Shared kernel impls for use in other backends.
export { simpleAbsImpl } from './kernels/Abs';
export { addImpl } from './kernels/Add';
export { ceilImpl } from './kernels/Ceil';
export { expImpl } from './kernels/Exp';
export { expm1Impl } from './kernels/Expm1';
export { floorImpl } from './kernels/Floor';
export { logImpl } from './kernels/Log';
export { maxImpl } from './kernels/Max_impl';
export { multiplyImpl } from './kernels/Multiply';
export { rsqrtImpl } from './kernels/Rsqrt';
export { sliceImpl } from './kernels/Slice';
export { subImpl } from './kernels/Sub';
export { transposeImpl } from './kernels/Transpose_impl';
export { uniqueImpl } from './kernels/Unique_impl';
//# sourceMappingURL=shared.js.map